import T from 'Components/Helpers/translate';
import AppService from 'App/legacy/AppService';

// Hand-kept against base's OUTSIDE_EU_REFUSAL (base/src/core/outsideEuRefusal.ts).
const OUTSIDE_EU_REFUSAL = 'ai_outside_eu_off';

/** The reply bubble for a failed turn: the stream's own message is internal, only its codes are explained. */
export function assistantErrorText(error: string): string {
	if (error === 'api_key_not_configured') {
		return T('assistant.errorApiKey');
	}
	if (error === OUTSIDE_EU_REFUSAL) {
		return T(AppService.getSelf()?.administrator ? 'aiOptIn.blocked.admin' : 'aiOptIn.blocked.user');
	}
	return T('assistant.errorOccurred');
}
